import { render, staticRenderFns } from "./EarnCoin.vue?vue&type=template&id=7abde360&scoped=true&"
import script from "./EarnCoin.vue?vue&type=script&lang=ts&"
export * from "./EarnCoin.vue?vue&type=script&lang=ts&"
import style0 from "./EarnCoin.scss?vue&type=style&index=0&id=7abde360&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abde360",
  null
  
)

export default component.exports